import { Typography } from '@material-ui/core';
import '../../styles/Globales.scss';
import '../../styles/ProductosConfirmacion.scss';

import React, { Component } from 'react';

export default class ProductoSinOfertaComponent extends Component {
  renderProductos = (productos) => {
    const result = productos.map((item, index) => {
      return (
        <div key={index}>
          <div className="lineaCredito">
            <div className="lineaCreditoTitulo">
              <Typography className="tituloBold">{item.nombreProducto}</Typography>
            </div>
          </div>
        </div>
      );
    });
    return result;
  };
  render() {
    return (
      <div className="ProductoConfirmar ">
        <div className="tituloProducto">
          <Typography className="tituloStepSolicitudAcordeon">{this.props.tituloProducto}</Typography>
        </div>
        <Typography className="bajadaTituloSinOferta">Para los siguientes productos no podemos ofrecerte una alternativa</Typography>
        <div className="productoSinOferta">{this.renderProductos(this.props.productos)}</div>
      </div>
    );
  }
}
